"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _header = _interopRequireDefault(require("./header"));

var Head =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Head, _PureComponent);

  function Head() {
    (0, _classCallCheck2["default"])(this, Head);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Head).apply(this, arguments));
  }

  (0, _createClass2["default"])(Head, [{
    key: "resolveSortDirection",
    value: function resolveSortDirection(field) {
      var _this$props = this.props,
          sortDirection = _this$props.sortDirection,
          defaultSortDirection = _this$props.defaultSortDirection;

      if (this.isSorted(field)) {
        return sortDirection;
      }

      return defaultSortDirection;
    }
  }, {
    key: "isSorted",
    value: function isSorted(field) {
      var sortedBy = this.props.sortedBy;

      if (field) {
        return field === sortedBy;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          columns = _this$props2.columns,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["columns"]);

      if (columns) {
        return columns.map(function (column, index) {
          var header = column.header,
              field = column.field,
              columnRest = (0, _objectWithoutProperties2["default"])(column, ["header", "field"]);
          var key = "header-".concat(index);
          return _react["default"].createElement(_header["default"], (0, _extends2["default"])({}, rest, columnRest, {
            key: key,
            colIndex: index,
            content: header,
            sortDirection: _this.resolveSortDirection(field),
            isSorted: _this.isSorted(field),
            field: field
          }));
        });
      }

      return null;
    }
  }]);
  return Head;
}(_react.PureComponent);

exports["default"] = Head;
Head.propTypes = {
  columns: _propTypes["default"].array,
  sortDirection: _propTypes["default"].string,
  defaultSortDirection: _propTypes["default"].string,
  sortedBy: _propTypes["default"].string
};
Head.defaultProps = {
  columns: undefined,
  sortDirection: undefined,
  defaultSortDirection: 'asc',
  sortedBy: undefined
};